import React, { PureComponent } from "react";
import styles from "./otherLog.module.less"
import PropTypes from "prop-types";
import { Spin, Timeline, Empty } from "antd"
import { connect } from "dva";
import InfiniteScroll from 'react-infinite-scroller';
import classnames from 'classnames';
import * as DICT from "@/utils/dict"
import http from "@/http"
import { handleAlarmContext2Props } from "../../../../decorator/context2Props"
import ReactResizeDetector from 'react-resize-detector';
import Tag from "@/components/Tag";

const HttpOtherAction = http.tokiot.device.otherAction;
class OtherLog extends PureComponent {
    divRef = React.createRef();
    state = {
        otherList: [],
        loading: false,
        pageNumber: 0,
        pageTotal: 0,
    };

    static contextTypes = {
        handleAlarm: PropTypes.func,
    }

    componentDidMount() {
        this.loadEventList();
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.refreshKey != this.props.refreshKey) {
            this.loadEventList();
        }
    }

    loadEventList = (page = 1, size = 10) => {
        const { deviceInfo } = this.props;
        let { otherList, pageTotal } = this.state;
        if (deviceInfo && deviceInfo.id && deviceInfo.id.length > 0 && (page === 1 || page <= pageTotal)) {
            this.setState({ loading: true });
            let data = {
                deviceId: deviceInfo.id,
                page: page,
                size: size,
            };
            HttpOtherAction.list(data).then((ret) => {
                if (ret && ret.rows && ret.rows.length > 0) {
                    if (ret.pageNumber == 1)
                        otherList = [];
                    this.setState({ otherList: otherList.concat(ret.rows), loading: false, pageNumber: ret.pageNumber, pageTotal: ret.pageTotal });
                } else {
                    this.setState({ loading: false, pageTotal: 0 });
                }
            });
        }
    }

    typeChange = (type) => {
        this.setState({ selectType: type });
    }

    render() {
        const { otherList, pageNumber, loading } = this.state;
        return (
            <ReactResizeDetector handleHeight>
                {({ width, height }) => {
                    let style = {};
                    if (height > 0) {
                        style.height = height;
                    }
                    return (
                        <div className={styles.main} >
                            <Spin className={styles.span} spinning={loading} >
                                {otherList && otherList.length > 0 ?
                                    <div className={styles.alarmListDiv} style={style}>
                                        <InfiniteScroll
                                            initialLoad={false}
                                            pageStart={0}
                                            loadMore={e => { this.loadEventList(pageNumber + 1, 10) }}
                                            hasMore={!loading}
                                            useWindow={false}
                                        >
                                            <Timeline>
                                                {
                                                    otherList.map(other => {
                                                        return (
                                                            <Timeline.Item className={styles.timelineItem} >
                                                                <div className={styles.alarmMainDiv}>
                                                                    <div className={styles.alarmDiv} >
                                                                        <div className={styles.alarmInfo}>
                                                                            <span className={styles.text}>{other.createdTime}</span>
                                                                            <div className={styles.row}>
                                                                                <span className={styles.text}>{other.actionUser}</span>
                                                                                <span className={styles.text}>{other.content}</span>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </Timeline.Item>
                                                        )
                                                    })
                                                }
                                            </Timeline>
                                        </InfiniteScroll>
                                    </div>
                                    :
                                    <Empty className={styles.empty} image={Empty.PRESENTED_IMAGE_SIMPLE} description={`暂无数据`} />
                                }
                            </Spin>
                        </div>
                    )
                }}
            </ReactResizeDetector>
        )
    }
}
export default OtherLog